import { Card, Flex, FormStatus, H2, P, Tabs } from '@dnb/eufemia';
import { TabsData } from '@dnb/eufemia/components/tabs';
import { Decision } from '@portals/shared/portal/AppApiEntitlementDto';
import { useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

import ScopeRequestCard from '@/pages/profile/apps/application/components/ScopeRequestCard';

import { ApiProviderPageOutletContext } from '../..';
import RequestNewScope from './RequestNewScope';

import style from './ScopeRequestSection.module.css';

const tabsData: TabsData = [
  { title: 'Pending', key: Decision.PENDING },
  { title: 'Denied', key: Decision.DENIED },
];

export default function ScopeRequestSection() {
  const { api, mutate } = useOutletContext<ApiProviderPageOutletContext>();

  const [selectedTab, setSelectedTab] = useState<Decision>(Decision.PENDING);

  const pendingScopeText =
    'You have a scope that is awaiting approval. ' +
    'The scope request will be approved by the CIAM team before it is completed. ' +
    'During the process they have been sent a notification about your request. ' +
    'Once they have reviewed it and given their decision you will be notified. ' +
    'If you have any questions or need to follow up, please reach out to the ' +
    'team on Slack at #identity-help.';

  const filteredRequests = useMemo(
    () => api.scopeRequests.filter((request) => request.reviewStatus === selectedTab),
    [api.scopeRequests, selectedTab],
  );

  const hasPendingScopes = useMemo(
    () => filteredRequests.some((request) => request.reviewStatus === 'PENDING'),
    [filteredRequests],
  );
  return (
    <Card direction="vertical">
      <Flex.Horizontal
        align="baseline"
        bottom="x-small"
        className={style['HeaderContainer']}
        justify="space-between"
        stretch
      >
        <H2 bottom="small">Scope requests</H2>
        <RequestNewScope apiSlug={api.slug} onSuccess={mutate} />
      </Flex.Horizontal>

      <div>
        <Tabs
          bottom="small"
          data={tabsData}
          noBorder
          onChange={({ selectedKey }) => setSelectedTab(selectedKey as Decision)}
          selectedKey={selectedTab}
        />
      </div>
      <Flex.Stack gap="small" stretch wrap={false}>
        {hasPendingScopes && selectedTab === Decision.PENDING && (
          <FormStatus state="information" stretch text={pendingScopeText} />
        )}

        {filteredRequests && filteredRequests.length > 0 ? (
          filteredRequests.map((request) => (
            <ScopeRequestCard key={request.id} onSuccess={mutate} scopeRequest={request} />
          ))
        ) : (
          <P>No {selectedTab.toLowerCase()} scope requests.</P>
        )}
      </Flex.Stack>
    </Card>
  );
}
